module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/step4-pict02-full-28f05d906fbc15e766724653a29ba1d9.jpg";